module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0118-account-list/account-list.component.css
// module id = ./src/app/a0118-account-list/account-list.component.css
// module chunks = main